import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsCommunityAskMeAnythingEnabled = () => boolean;
export const useIsCommunityAskMeAnythingEnabled: UseIsCommunityAskMeAnythingEnabled = () => {
  const isVivaEngagePremiumEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const isCommunityAskMeAnythingEnabled = useExperimentTreatmentWithoutReporting(Experiment.CommunityAma) === true;

  return isVivaEngagePremiumEnabled && isCommunityAskMeAnythingEnabled;
};
